<div class="error-container">
    <div class="">
        <img src="../../assets/img/serverError.svg" class="server-error-iocn" alt="server-error-image" />
    </div>
    <p class="sever-error-message">{{strings.serverDownErrorMessage}}
    </p>
    <button (click)="handleDashboard()" class="sever-error-btn" type="button">{{strings.goToDashboard}}</button>
</div>